import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button, CardHeader, CardBody, FormSelect } from "react-bootstrap";
// import WhiteObjectApi from "../../api/WhiteObjectApi";
import Select from "react-select";
import moment from "moment"; //Added by shivani 6 aug bug 64
import { regExPattern } from "../../utils/regExPattern";
import CityState from "../../constants/CityState.json";
import "./EnquiryForm.css"; // Ensure this file exists for custom styling
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import * as constants from '../../constants/CONSTANT';
import logo from "../../assets/img/fuziElevatorsLogo.jpg";
import detailsLogo from "../../assets/img/fuziDetailsLogo.jpg";
import { validationMessages } from "../../utils/messages";
import { formatDate } from "../../utils/helper";
import PubSub from "pubsub-js";
import { FaPhoneAlt, FaPhone } from "react-icons/fa"; // phone icons

const LeadEdit = () => {
  // Define initial errors i.e. required field and their message
  const initialErrors = {
    leadtype: { message: "Please provide a lead type." },
    lead_name: { message: "Please provide a lead name." },
    phone: { message: "Please provide phone." },
    customer_type: { message: "Please provide a customer type." },
  };
  // enquiry state
  const [enquiry, setEnquiry] = useState({is_gst: "Yes"});
  //errors state
  const [errors, setErrors] = useState(initialErrors);
  // validation state
  const [validated, setValidated] = useState(false);

  // Handle City & state values
  const [states, setStates] = useState([...(new Set(CityState.map((item) => item.state)))]);
  const [cities, setCities] = useState(null);

  // enquiry result 
  const [enquiryResult, setEnquiryResult] = useState(null);
  // If state value changed set the cities according to state
  useEffect(() => {
    setCities([...(new Set(CityState.filter((item) => item.state == enquiry?.state).map((item) => item.name)))]);
  }, [enquiry?.state]);

  // products
  const [products, setProducts] = useState([]);
  const [refContact, setRefContact] = useState([]);

  // offers
  const [offers, setOffers] = useState([]);
 
  useEffect(() => {
    async function init() {
      const fetchedContacts = await fuziElevatorsApi.fetchProductsForEnquiry();
      console.log('fetchedContacts', fetchedContacts);
      Array.isArray(fetchedContacts) && setProducts(fetchedContacts?.map((fetchedContact) => ({ id: fetchedContact?.id, name: `${fetchedContact?.product_name || ""}` })));

      const fetchedRefrealContact = await fuziElevatorsApi.fetchContactsForEnquiry();
      console.log('fetchedContacts', fetchedRefrealContact);
      Array.isArray(fetchedRefrealContact) && setRefContact(fetchedRefrealContact?.map((fetchRefContact) => ({ id: fetchRefContact?.id, name: `${fetchRefContact?.firstname || ""} ${fetchRefContact?.lastname || ""}` })));
    }
    init();
  }, []);

  const [successMessage, setSuccessMessage] = useState(false);
  const [enquiryFormHide, setEnquiryFormHide] = useState(true);
  const [latitudev1, setLatitudev1] = useState(null);
  const [longitudev1, setLongitudev1] = useState(null);
  const [addressv1, setAddressv1] = useState(null);

  const [locationLink, setLocationLink] = useState(""); 
  const [timeSlot, setTimeSlot] = useState('');  
  const [typeOfOrder, setTypeOrder] = useState('');   


  // onChange Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "leadtype") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.leadType.required } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "lead_name") {
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.leadName.required } }));
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.leadName.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "email") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.email.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name === "date_of_birth") { }
    else if (name === "phone") {
      if (value === "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.required } }));
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "whatsapp_no") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.whatsappNumber.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "pincode") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.pinCode.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "customer_type") {
      value != 'Corporate' && setEnquiry((pre)=>({...pre,company_name:''}));
      if (value == "") {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.customerType.required } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "company_name") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.name.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "is_gst") {
      value != 'Yes' && setEnquiry((pre)=>({...pre,gst_no:''}));
    }
    else if (name == "gst_no") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.gstNo.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "customer_primary_name") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.name.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "customer_primary_phone") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "customer_secondry_name") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.name.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "competitor_name") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.name.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    else if (name == "qty") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.quantity.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "city") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.city.required },
        }));
      } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.city.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    else if (name == "country") {
      if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
        setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.country.invalid } }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    setValidated(true);
    setEnquiry((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;
    // if (enquiry?.salutation) { }

    if (enquiry?.leadtype) {

      if (enquiry?.leadtype == "") {
        setErrors((prev) => ({ ...prev, 'leadtype': { message: validationMessages.leadType.required } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['leadtype'];
          return { ...prev };
        });
      }

    }

    if (enquiry?.lead_name) {

      if (enquiry?.lead_name == "") {
        setErrors((prev) => ({ ...prev, 'lead_name': { message: validationMessages.leadName.required } }));
        isError = true;
      } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.lead_name))) {
        setErrors((prev) => ({ ...prev, 'lead_name': { message: validationMessages.leadName.invalid } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['lead_name'];
          return { ...prev };
        });
      }

    }

    if (enquiry?.email) {
      if (enquiry?.email != "" && regExPattern?.email && (!RegExp(regExPattern.email).test(enquiry.email))) {
        setErrors((prev) => ({ ...prev, 'email': { message: validationMessages.email.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['email'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.date_of_birth) { }

    if (enquiry?.phone) {
      if (enquiry?.phone == "") {
        setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.required } }));
        isError = true;
      } else if (regExPattern?.phone && (!RegExp(regExPattern.phone).test(enquiry.phone))) {
        setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.invalid } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['phone'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.whatsapp_no) {
      if (enquiry?.whatsapp_no != "" && regExPattern?.phone && (!RegExp(regExPattern.phone).test(enquiry.whatsapp_no))) {
        setErrors((prev) => ({ ...prev, 'whatsapp_no': { message: validationMessages.whatsappNumber.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['whatsapp_no'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.pincode) {
      if (enquiry?.pincode != "" && regExPattern?.pinCode && (!RegExp(regExPattern.pinCode).test(enquiry.pincode))) {
        setErrors((prev) => ({ ...prev, 'pincode': { message: validationMessages.pinCode.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['pincode'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.country) {
      if (enquiry?.country != "" && regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.country))) {
        setErrors((prev) => ({ ...prev, 'country': { message: validationMessages.country.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['country'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.customer_type) {

      if (enquiry?.customer_type == "") {
        setErrors((prev) => ({ ...prev, 'customer_type': { message: validationMessages.customerType.required } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['customer_type'];
          return { ...prev };
        });
      }

    }

    if (enquiry?.company_name) {
      if (enquiry?.company_name != "" && regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.company_name))) {
        setErrors((prev) => ({ ...prev, 'company_name': { message: validationMessages.name.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['company_name'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.gst_no) {
      if (enquiry?.gst_no != "" && regExPattern?.gstNo && (!RegExp(regExPattern.gstNo).test(enquiry.gst_no))) {
        setErrors((prev) => ({ ...prev, 'gst_no': { message: validationMessages.gstNo.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['gst_no'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.customer_primary_name) {
      if (enquiry?.customer_primary_name != "" && regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.customer_primary_name))) {
        setErrors((prev) => ({ ...prev, 'customer_primary_name': { message: validationMessages.name.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['customer_primary_name'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.customer_primary_phone) {
      if (enquiry?.customer_primary_phone != "" && regExPattern?.phone && (!RegExp(regExPattern.phone).test(enquiry.customer_primary_phone))) {
        setErrors((prev) => ({ ...prev, 'customer_primary_phone': { message: validationMessages.phone.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['customer_primary_phone'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.customer_secondry_name) {
      if (enquiry?.customer_secondry_name != "" && regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.customer_secondry_name))) {
        setErrors((prev) => ({ ...prev, 'customer_secondry_name': { message: validationMessages.name.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['customer_secondry_name'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.competitor_name) {
      if (enquiry?.competitor_name != "" && regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.competitor_name))) {
        setErrors((prev) => ({ ...prev, 'competitor_name': { message: validationMessages.name.invalid } }));
        isError = true;

      } else {
        setErrors((prev) => {
          delete prev['competitor_name'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.qty) {
      if (enquiry?.qty != "" && regExPattern?.quantity && (!RegExp(regExPattern.quantity).test(enquiry.qty))) {
        setErrors((prev) => ({ ...prev, 'qty': { message: validationMessages.quantity.invalid } }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev['qty'];
          return { ...prev };
        });
      }
    }

    if (enquiry?.city) {
      if (enquiry?.city == "") {
        setErrors((prev) => ({
          ...prev,
          city: { message: validationMessages.city.required },
        }));
        isError = true;
      } else if (regExPattern?.name && (!RegExp(regExPattern.name).test(enquiry.city))) {
        setErrors((prev) => ({ ...prev, 'city': { message: validationMessages.city.invalid } }));
        isError = true;
      }  else {
        setErrors((prev) => {
          delete prev["city"];
          return { ...prev };
        });
      }
    }

    if (!enquiry?.lead_name) {
      setErrors((prev) => ({
        ...prev,
        lead_name: { message: validationMessages.leadName.required },
      }));
      isError = true;
    }
    if (!enquiry?.leadtype) {
      setErrors((prev) => ({
        ...prev,
        leadtype: { message: validationMessages.leadType.required },
      }));
      isError = true;
    } 
    if (!enquiry?.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: { message: validationMessages.phone.required },
      }));
      isError = true;
    } 
    if (!enquiry?.customer_type) {
      setErrors((prev) => ({
        ...prev,
        customer_type: { message: validationMessages.customerType.required },
      }));
      isError = true;
    }
    if (!enquiry?.city) {
      setErrors((prev) => ({
        ...prev,
        city: { message: validationMessages.city.required },
      }));
      isError = true;
    }

    // console.log('errors',errors);
    // console.log('TEST ',RegExp(regExPattern.quantity).test(enquiry.qty));
    // console.log('isError',isError);
    return isError;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log('enquiry', enquiry);
    // console.log('errors', errors);

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    // console.log('enquiry', enquiry);
    // console.log('errors', errors);
    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    const record = { ...enquiry };
    if (record?.date_of_birth) {
      record.date_of_birth = moment(record.date_of_birth).format("DD MMM, yyyy");
    }
    if (record?.anniversary_date) {
      record.anniversary_date = moment(record.anniversary_date).format("DD MMM, yyyy");
    }

    // record.time_slot = timeSlot;
    // record.type_of_order = typeOfOrder;
    // record.title = "Customer Enquiry";
    record.lead_status = "Enquiry Pending";
    record.createdbyid = "59b02983-536c-4899-9c2e-86c7145b29b9";
    record.lastmodifiedbyid = "59b02983-536c-4899-9c2e-86c7145b29b9";
    record.owner_id = "59b02983-536c-4899-9c2e-86c7145b29b9";

    if (record.customer_type == "Individual") {
      record.company_name = "";
      record.gst_no = "";
    }
    console.log("Enquiry Data", record);
    //Delete fields from JSON
    delete record.product_name;
    delete record.contact_name;

    const result = await fuziElevatorsApi.createEnquiry(record);
    if (result?.success) {
      // PubSub.publish("RECORD_SAVED_TOAST", {
      //   title: "Record created",
      //   message: "Record created successfully",
      // });
      // navigate(`${ROUTES.CONTACT.LIST}/${result.id}`, { state: result.data });
      setEnquiryResult(result.data);
      setEnquiryFormHide(false);
      setSuccessMessage(true);
    } else {
      // PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result?.errors || 'Some error found' });
      // console.log(result?.errors);
      alert(result?.errors || 'Some error found');
    }
    // if (result) {
    //   setEnquiryResult(result);
    //   setEnquiryFormHide(false);
    //   setSuccessMessage(true);
    // } else {
    //   alert("Submission failed. Please try again.");
    // }
  };



  // useEffect(() => {
  //   const loadGoogleMapsScript = () => {
  //     if (!window.google || !window.google.maps) {
  //       const existingScript = document.querySelector(
  //         'script[src*="maps.googleapis.com"]'
  //       );
  //       if (!existingScript) {
  //         const googleMapScript = document.createElement("script");
  //         googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtztwOW6bufAlbBWfO1k5FdZTkpUP_gmI&callback=initMap`;
  //         googleMapScript.async = true;
  //         googleMapScript.defer = true;
  //         window.document.body.appendChild(googleMapScript);
  //       }
  //     } else {
  //       window.initMap();
  //     }
  //   };

  //   window.initMap = () => {
  //     myMapFunction();
  //   };

  //   loadGoogleMapsScript();
  // }, [latitudev1, longitudev1, addressv1]);

  // const myMapFunction = async () => {
  //   if (!window.google) {
  //     console.error("Google Maps API is not loaded.");
  //     return;
  //   }

  //   const geocoder = new window.google.maps.Geocoder();

  //   if (latitudev1 && longitudev1) {
  //     const location = new window.google.maps.LatLng(latitudev1, longitudev1);
  //     const mapProp = {
  //       center: location,
  //       zoom: 14,
  //     };

  //     const map = new window.google.maps.Map(
  //       document.getElementById("googleMapaddress"),
  //       mapProp
  //     );

  //     const marker = new window.google.maps.Marker({
  //       map,
  //       position: location,
  //       title: addressv1,
  //     });

  //     const infowindow = new window.google.maps.InfoWindow({
  //       content: addressv1,
  //     });

  //     marker.addListener("click", () => {
  //       infowindow.open(map, marker);
  //     });
  //   } else if (addressv1) {
  //     geocoder.geocode({ address: addressv1 }, (results, status) => {
  //       if (status === "OK") {
  //         const location = results[0].geometry.location;
  //         setLatitudev1(location.lat());
  //         setLongitudev1(location.lng());

  //         const mapProp = {
  //           center: location,
  //           zoom: 14,
  //         };

  //         const map = new window.google.maps.Map(
  //           document.getElementById("googleMapaddress"),
  //           mapProp
  //         );

  //         const marker = new window.google.maps.Marker({
  //           map,
  //           position: location,
  //           title: results[0].formatted_address,
  //         });

  //         const infowindow = new window.google.maps.InfoWindow({
  //           content: results[0].formatted_address,
  //         });

  //         marker.addListener("click", () => {
  //           infowindow.open(map, marker);
  //         });

  //         setAddressv1(results[0].formatted_address);
  //       } else {
  //         console.error(
  //           "Geocode was not successful for the following reason: " + status
  //         );
  //       }
  //     });
  //   } else {
  //     console.error("Address is not provided.");
  //   }
  // };



  return (
    <Container className="d-flex justify-content-center align-items-center">
      {enquiryFormHide && (
        <Row className="w-100">

          <Col lg={8} className="mx-auto">
            <Form
              className="mt-3"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >

            <Card>
                {/* Changes in card header by shahir hussain */}
                <CardHeader className="justify-content-between align-items-center d-flex px-2" style={{ position: 'relative',backgroundColor:"#FFFFFF" }}>
                  {/* <div className="text-start">
                    <div style={{ fontSize: "13px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "6px",color: "" }}>
                      <FaPhoneAlt style={{ color: "" }} /> 9928019671
                    </div>
                    <div style={{ fontSize: "13px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "6px",color: "" }}>
                      <FaPhoneAlt style={{ color: "" }} /> 9950997937
                    </div>
                    <div style={{ fontSize: "13px", fontWeight: "bold", display: "flex", alignItems: "center", gap: "6px",color: "" }}>
                      <FaPhone style={{ color: "" }} /> 0141 - 2620168
                    </div>
                  </div> */}

                  <div className="text-center" style={{ flexGrow: 1 }}>
                  <img
                    // src={logo}
                    src="/fuzi_classic_elevators_pvt_ltd_cover.png"
                    className=""
                    alt="Fuzi Elevators"
                    style={{
                      width: "400px",
                      height: "140px",
                      // marginRight: "151px",
                      filter: "unset",
                      mixBlendMode: ""
                    }}
                  />
                  {/* <div style={{ fontSize: "18px", fontWeight: "bold", marginTop: "5px",color: "" }}>
                    <span>360, Guru Nanak Pura, Raja Park, Jaipur - 302004</span>
                  </div> */}
                  </div>
                  
                </CardHeader>
              
                <CardBody className="">

                  <Row lg={12} className="view-form ">
                    {/* <Col md={12} className="section-header">Enquiry Information</Col> */}

                    <>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicDate"
                          >
                            Enquiry Date
                          </Form.Label>
                          <Form.Control
                            disabled
                            value={moment().format('DD-MM-YYYY')}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group
                        >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicLastName"
                          >
                            Lead Name
                          </Form.Label>
                          <Form.Control
                            required
                            pattern={regExPattern.name}
                            type="text"
                            name="lead_name"
                            placeholder="Enter Lead Name"
                            value={enquiry?.lead_name || ""}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.lead_name?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicLead"
                          >
                            Lead Type
                          </Form.Label>
                          <Form.Select
                            required
                            placeholder="Select lead type"
                            aria-label="Select lead type"
                            name="leadtype"
                            value={enquiry?.leadtype || ""}
                            onChange={handleChange}
                          >
                            <option value="">---Select---</option>
                            {['New', 'Modification', 'AMC', 'OneTime'].map((item, index) => <option value={item} key={index}>{item}</option>)}
                          </Form.Select>

                          <Form.Control.Feedback type="invalid">
                            {errors?.leadtype?.message}
                          </Form.Control.Feedback>

                        </Form.Group>
                      </Col> 
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicEmail"
                          >
                            Email
                          </Form.Label>
                          <Form.Control
                            pattern={regExPattern.email}
                            type="email"
                            name="email"
                            placeholder="Enter Email"
                            value={enquiry?.email || ""}
                            onChange={handleChange}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors?.email?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group  >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPhone"
                          >
                            Phone
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            name="phone"
                            placeholder="Enter Phone"
                            value={enquiry?.phone || ""}
                            onChange={handleChange}
                            maxLength={10}
                            pattern={regExPattern.phone}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.phone?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group  >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicWhatsAppNumber"
                          >
                            WhatsApp Number.
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="whatsapp_no"
                            placeholder="Enter WhatsApp Number"
                            value={enquiry?.whatsapp_no || ""}
                            onChange={handleChange}
                            maxLength={10}
                            pattern={regExPattern.phone}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors?.whatsapp_no?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group  >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicEmail"
                          >
                            Date of Birth
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date_of_birth"
                            placeholder="Select Date Of Birth"
                            value={
                              enquiry?.date_of_birth
                                ? formatDate(enquiry.date_of_birth)
                                : ""
                            }
                            onChange={handleChange}
                            max={moment(new Date()).format("YYYY-MM-DD")}
                            onKeyDown={(e)=>e.preventDefault()}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.date_of_birth?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formAnniversaryDate"
                          >
                            Anniversary Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="anniversary_date"
                            placeholder="Select anniversary date"
                            value={
                              enquiry?.anniversary_date
                                ? formatDate(enquiry.anniversary_date)
                                : ""
                            }
                            onChange={handleChange}
                            max={moment(new Date()).format("YYYY-MM-DD")}
                            onKeyDown={(e)=>e.preventDefault()}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.anniversary_date?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicLeadSource"
                          >
                            Enquiry Source
                          </Form.Label>
                          <Form.Select
                            placeholder="Select Lead Source"
                            aria-label="Select Lead Source"
                            name="leadsource"
                            value={enquiry?.leadsource || ""}
                            onChange={handleChange}
                          >
                            <option value="">---Select---</option>
                            {constants.sourceNames?.map((item, index) => <option value={item} key={index}>{item}</option>)}

                          </Form.Select>

                          <Form.Control.Feedback type="invalid">
                            {errors?.leadsource?.message}
                          </Form.Control.Feedback>

                        </Form.Group>
                      </Col>
                    </>

                    <>
                      <Col md={12} className="section-header">Address Information</Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCompany"
                          >
                            Location Link
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="location_link"
                            placeholder="Enter Location Link"
                            value={enquiry?.location_link || ""}
                            onChange={(e) => handleChange(e)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.location_link?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicStreet"
                          >
                            Address
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="address"
                            placeholder="Enter address"
                            value={enquiry?.address || ""}
                            onChange={handleChange}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors?.address?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicState"
                          >
                            State
                          </Form.Label>

                          <Select
                            placeholder="Select your state"
                            options={states?.map((state) => ({ 'value': state, 'label': state }))}
                            onChange={(e) => {
                              setEnquiry((prev) => ({ ...prev, city: "" }));
                              handleChange({ target: { name: "state", 'value': e.value } });
                            }}
                            value={enquiry?.state ? { value: enquiry?.state, label: enquiry?.state } : ""}
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.state?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCity"
                          >
                            City
                          </Form.Label>
                          <Form.Control
                            required
                            pattern={regExPattern.name}
                            type="text"
                            name="city"
                            placeholder="Enter Enter City Name"
                            value={enquiry?.city || ""}
                            onChange={handleChange}
                          />
                          {/* <Select
                            placeholder="Select your city"
                            options={cities?.map((city) => ({ 'value': city, 'label': city }))}
                            onChange={(e) => {
                              handleChange({ target: { name: "city", 'value': e.value } });
                            }}
                            value={enquiry?.city ? { value: enquiry?.city, label: enquiry?.city } : ""}
                          /> */}

                          <Form.Control.Feedback type="invalid">
                            {errors?.city?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group 
                          className="form-view-label"
                          htmlFor={"formBasicOfficeAddress"}
                        >
                          <Form.Label>Office Address</Form.Label>
                          <Form.Control
                            type="text"
                            name="office_address"
                            placeholder="Enter office address"
                            value={enquiry?.office_address || ""}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.office_address?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
  
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicOfficeCity"
                          >
                            Office City
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="office_city"
                            placeholder="Enter office city name"
                            value={enquiry?.office_city || ""}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.office_city?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicPin"
                          >
                            Pincode
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="pincode"
                            placeholder="Enter PinCode"
                            value={enquiry?.pincode || ""}
                            onChange={handleChange}
                            pattern={regExPattern.pinCode}
                            maxLength={6}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors?.pincode?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group  >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCountry"
                          >
                            Country
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="country"
                            placeholder="Enter Country"
                            value={enquiry?.country || ""}
                            onChange={handleChange}
                            pattern={regExPattern.name}
                          />

                          <Form.Control.Feedback type="invalid">
                            {errors?.country?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </>

                    <>
                      <Col md={12} className="section-header">Customer Information</Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerType"
                          >
                            Customer Type
                          </Form.Label>
                          <Form.Select
                            required
                            placeholder="Select Customer type"
                            aria-label="Select Customer type"
                            name="customer_type"
                            value={enquiry?.customer_type || ""}
                            onChange={handleChange}
                          >
                            <option value="">---Select---</option>
                            <option value="Individual">Individual</option>
                            <option value="Corporate">Corporate</option>

                          </Form.Select>

                          <Form.Control.Feedback type="invalid">
                            {errors?.customer_type?.message}
                          </Form.Control.Feedback>

                        </Form.Group>
                      </Col>
                      {enquiry?.customer_type === "Corporate" &&
                        <>
                          <Col lg={6}>
                            <Form.Group >
                              <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicCompanyName"
                              >
                                Company Name
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="company_name"
                                placeholder="Enter company name"
                                value={enquiry?.company_name || ""}
                                onChange={handleChange}
                                pattern={regExPattern.name}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors?.company_name?.message}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </>
                      }
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicSector "
                          >
                            Sector
                          </Form.Label>
                          <Form.Select
                            placeholder="Select sector"
                            aria-label="Select sector"
                            name="sector"
                            value={enquiry?.sector || ""}
                            onChange={handleChange}
                          >
                            <option value="">---Select---</option>
                            {["Government site", "Customer is private", "Government customer direct with us"].map((item, index) => <option value={item} key={index}>{item}</option>)}
                          </Form.Select>

                          <Form.Control.Feedback type="invalid">
                            {errors?.sector?.message}
                          </Form.Control.Feedback>

                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicIsGst"
                          >
                            Is GST Applicable
                          </Form.Label>
                          <FormSelect
                            name="is_gst"
                            value={enquiry?.is_gst || ""}
                            onChange={handleChange}
                          >
                            <option value={""}>--select--</option>
                            <option value={"Yes"}>Yes</option>
                            <option value={"No"}>No</option>
                          </FormSelect>
                          <Form.Control.Feedback type="invalid">
                            {errors?.is_gst?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {enquiry?.is_gst === "Yes" && (
                        <Col lg={6}>
                          <Form.Group >
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicCompanyName"
                            >
                              GST Number
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="gst_no"
                              placeholder="Enter gst number"
                              value={enquiry?.gst_no || ""}
                              // onChange={handleChange}
                              onChange={(e) => {
                                const value = e.target.value;
                                setEnquiry(prev => ({
                                  ...prev,
                                  gst_no: value.replace(/\s+/g, "").toUpperCase()
                                }));
                              }}
                              pattern={regExPattern.gstNo}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.gst_no?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      )}
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCompetitorName "
                          >
                            Competitor Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="competitor_name"
                            placeholder="Enter competitor name "
                            value={enquiry?.competitor_name || ""}
                            onChange={handleChange}
                            pattern={regExPattern.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.competitor_name?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerPrimaryName"
                          >
                            Customer Primary Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="customer_primary_name"
                            placeholder="Enter customer primary name"
                            value={enquiry?.customer_primary_name || ""}
                            onChange={handleChange}
                            pattern={regExPattern.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.customer_primary_name?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group  >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerPrimaryPhone"
                          >
                            Customer Primary Phone
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="customer_primary_phone"
                            placeholder="Enter customer primary phone"
                            value={enquiry?.customer_primary_phone || ""}
                            onChange={handleChange}
                            maxLength={10}
                            pattern={regExPattern.phone}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.customer_primary_phone?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerPrimaryName"
                          >
                            Second Person Name
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="customer_secondry_name"
                            placeholder="Enter Second Person Name"
                            value={enquiry?.customer_secondry_name || ""}
                            onChange={handleChange}
                            pattern={regExPattern.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.customer_secondry_name?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerSecondaryPhone"
                          >
                            Second Person Phone
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="customer_secondary_phone"
                            placeholder="Enter second person phone"
                            value={enquiry?.customer_secondary_phone || ""}
                            onChange={handleChange}
                            pattern={regExPattern.phone}
                            maxLength={10}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.customer_secondary_phone?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerSecondaryDesignation"
                          >
                            Second Person Designation
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="customer_secondary_designation"
                            placeholder="Enter second person designation"
                            value={enquiry?.customer_secondary_designation || ""}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.customer_secondary_designation?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </>

                    <>
                      <Col md={12} className="section-header">Service Information</Col>
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicState"
                          >
                            Product
                          </Form.Label>

                          <Select
                            placeholder="Select your product"
                            classNamePrefix="react-select"
                            options={products?.map((product) => ({ 'value': product?.id, 'label': product?.name }))}
                            onChange={(e) => {
                              handleChange({ target: { name: "product_id", 'value': e.value } });
                              handleChange({ target: { name: "product_name", 'value': e.label } });
                            }}
                            value={enquiry?.product_id ? { value: enquiry?.product_id, label: enquiry?.product_name } : ""}
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.product_id?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicQuantity"
                          >
                            Quantity
                          </Form.Label>
                          <Form.Control
                            min={0}
                            type="number"
                            name="qty"
                            placeholder="Enter quantity"
                            value={enquiry?.qty || ""}
                            onChange={handleChange}
                            pattern={regExPattern.quantity}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.qty?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* commented by shahir hussain 13-06-2025 */}
                      {/* <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicState"
                          >
                            Offer
                          </Form.Label>

                          <Select
                            placeholder="Select your offer"
                            options={offers?.map((offer) => ({ 'value': offer?.id, 'label': offer?.name }))}
                            onChange={(e) => {
                              handleChange({ target: { name: "offer_id", 'value': e.value } });
                            }}
                            value={enquiry?.offer_id ? { value: enquiry?.offer_id, label: enquiry?.offer_name } : ""}
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.offer_id?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col> */}
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicState"
                          >
                            Referred  By
                          </Form.Label>

                          <Select
                            name="contact_id"
                            classNamePrefix="react-select"
                            // className={`${errors?.contact_id?.message ? 'border border-danger rounded' : 'border border-success rounded' }`}
                            placeholder="Select your reference name"
                            options={refContact?.map((contact) => ({ 'value': contact?.id, 'label': contact?.name }))}
                            onChange={(e) => {
                              handleChange({ target: { name: "contact_id", 'value': e.value } });
                              handleChange({ target: { name: "contact_name", 'value': e.label } });
                            }}
                            value={enquiry?.contact_id ? { value: enquiry?.contact_id, label: enquiry?.contact_name } : ""}
                          ></Select>
                          <Form.Control.Feedback type="invalid">
                            {errors?.contact_id?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col lg={6}>
                        <Form.Group >
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCustomerEnquiryRemark"
                          >
                            Enquiry Remark
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="enquiry_remark"
                            placeholder="Enter enquiry remark"
                            value={enquiry?.enquiry_remark || ""}
                            onChange={handleChange}
                            pattern={regExPattern.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.enquiry_remark?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {/* {enquiry.time_slot === "Specific" && (
                        <Col lg={6} className="mt-2">
                          <Form.Group controlId="formBasicLastName">
                            <Form.Label className="form-view-label">
                              Specific Time
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="specific_time"
                              placeholder="Enter Specific Time"
                              onChange={handleChange}
                            />
                          </Form.Group>
                        </Col>
                      )} */}
                      <Col lg={6} className="mt-2">
                        <Form.Group controlId="formBasicLastName">
                          <Form.Label className="form-view-label">
                            Site Visit Date
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="customer_site_visit_date"
                            placeholder="Select Site Visit Date"
                            // max={getTodayDate()} //Added by shivani 6 aug bug 64
                            onChange={handleChange}
                            max={moment(new Date()).format("YYYY-MM-DD")}
                            onKeyDown={(e)=>e.preventDefault()}
                          />
                        </Form.Group>
                      </Col>
                      <Col lg={6} className="mt-2">
                        <Form.Group controlId="formVisitType" className="mt-3">
                          <Form.Label style={{ marginLeft: "10px" }}>
                            Time Slot Of Visit
                          </Form.Label>
                          <div
                            className=""
                            style={{
                              justifyContent: "space-between",
                              marginLeft: "10px",
                            }}
                          >
                            <Form.Check
                              type="radio"
                              label="9 Am To 12 Noon"
                              name="time_slot"
                              id="9 Am To 12 Noon"
                              value="9 Am To 12 Noon"
                              onChange={handleChange}
                            />
                            <Form.Check
                              type="radio"
                              label="12 Noon To 3 Pm"
                              name="time_slot"
                              id="12 Noon To 3 Pm"
                              value="12 Noon To 3 Pm"
                              onChange={handleChange}
                            />
                            <Form.Check
                              type="radio"
                              label="3 Pm To 6 Pm"
                              name="time_slot"
                              id="3 Pm To 6 Pm"
                              value="3 Pm To 6 Pm"
                              onChange={handleChange}
                            />
                            <Form.Check
                              type="radio"
                              label="Specific"
                              name="time_slot"
                              id="Specific"
                              value="Specific"
                              onChange={handleChange}

                            />
                          </div>
                        </Form.Group>
                      </Col>
                      {/* <Col>
                        <Button
                          variant="success"
                          type="button"
                          onClick={()=>{}}
                          className={timeSlot === "Specific" ?'mt-2' : 'mt-4'}  
                        >
                          Get Location
                        </Button>
                        {'locationFetched' && locationLink && (
                          <div className="mt-2">
                            <a href={locationLink} target="_blank" rel="noopener noreferrer">
                              View Location on Google Maps
                            </a>
                          </div>
                        )}
                      </Col> */}
                    </>
                  </Row>
                </CardBody>
                <Card.Footer>
                  <Button
                    className="d-flex justify-content-end align-items-end float-end"
                    variant="primary"
                    type="submit"
                  >
                    Submit
                  </Button>
                </Card.Footer>
              </Card>
            </Form>
          </Col>
        </Row>
      )}
      {successMessage && (
        <Card className="text-center mt-3">
          <Card.Body>
            <Container>
              <div className="d-flex justify-content-center mt-3">
                <div className="blink green-tick rounded-circle">✔️</div>
              </div>
              <h5>Thank you for reaching out. Your enquiry details has been submitted, and our team will contact you soon.
                <br />
                Enquiry No. : {enquiryResult.enquiry_no}
              </h5>
              <img
                src={detailsLogo}
                alt="Fuzi Details logo"
                style={{
                  width: "auto",
                  height: "220px",
                  // marginRight: "151px",
                  filter: "",
                  mixBlendMode: ""
                }}
              />
            </Container>

          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default LeadEdit;